import * as actionTypes from "../actions/actionType";

const initialState = {
  user: [],
  token: "",
  toggleChatCoach: false,
  forgetPasswordToken: []
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.USER_SIGNUP:
      return {
        ...state,
        user: action.payload,
        token: action.payload.token,
      };
    case actionTypes.USER_LOGIN:
      return {
        ...state,
        user: action.payload,
      };
    case actionTypes.USER_LOGOUT:
      return {
        ...state,
        user: null,
      };
    case actionTypes.FORGET_PASSWORD:
      return {
        ...state,
        data: action.payload.data,
        status: action.payload.status,
        message: action.payload.message,
        error: action.payload.error || null,
      };

    case actionTypes.TOGGLE_CHAT_COACH:
      return { ...state, toggleChatCoach: action.payload };

    default:
      return state;
  }
};
